import {AppBar, Container, Toolbar, Typography} from "@mui/material";
import React from "react";

const TopBar = () => {
    return (
        <AppBar sx={{backgroundColor: "#eee"}} position="static" >
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    {/*<Typography*/}
                    {/*    variant="h6"*/}
                    {/*    noWrap*/}
                    {/*    component="a"*/}
                    {/*    href="#app-bar-with-responsive-menu"*/}
                    {/*    sx={{*/}
                    {/*        mr: 2,*/}
                    {/*        display: { xs: 'none', md: 'flex' },*/}
                    {/*        fontFamily: 'monospace',*/}
                    {/*        fontWeight: 700,*/}
                    {/*        letterSpacing: '.3rem',*/}
                    {/*        color: 'inherit',*/}
                    {/*        textDecoration: 'none',*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    LOGO*/}
                    {/*</Typography>*/}
                    <img src="/AiBabs-logo.svg" alt="logo" style={{height: "60px", margin: "10px"}}/>
                    {/*<Typography*/}
                    {/*    variant="h5"*/}
                    {/*    noWrap*/}
                    {/*    component="a"*/}
                    {/*    href="#app-bar-with-responsive-menu"*/}
                    {/*    sx={{*/}
                    {/*        mr: 2,*/}
                    {/*        display: { xs: 'flex', md: 'none' },*/}
                    {/*        flexGrow: 1,*/}
                    {/*    }}*/}
                    {/*>*/}
                </Toolbar>
            </Container>
        </AppBar>
    )
}

export default TopBar;